import { getEnv } from "./helpers";

export const API_BASE_URL = getEnv()?.VITE_API_URL || "http://localhost:5000/api";

export const ROUTES = {
  HOME: "/",
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  FORGOT_PASSWORD: "/auth/forgot-password",
  GROUNDS: "/grounds",
  GROUND_DETAILS: "/grounds/:id",
  EVENTS: "/events",
  EVENT_DETAILS: "/events/:id",
  SEAT_SELECTION: "/booking/seat-selection/:eventId",
  CHECKOUT: "/booking/checkout",
  CONFIRMATION: "/booking/confirmation",
  PROFILE: "/profile",
  DASHBOARD: {
    FAN: "/dashboard/fan",
    ORGANIZER: "/dashboard/organizer",
    MANAGER: "/dashboard/manager",
    ADMIN: "/dashboard/admin",
  },
} as const;

export const COUNTRIES = [
  { code: "LK", name: "Sri Lanka" },
  { code: "IN", name: "India" },
] as const;

export const CURRENCIES = {
  LKR: "LKR",
  INR: "INR",
  USD: "USD",
} as const;
